import { useEffect, useState } from "react";

const QUERY = "(min-width: 768px)";

/** Tracks the `md` breakpoint so layout-only duplication (desktop pane vs
 * mobile stack) doesn't double-mount stateful children like autosaved
 * forms — each with its own debouncer, which would let "flush before
 * Approve/Flag" miss whichever copy the user actually edited. */
export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window === "undefined" ? true : window.matchMedia(QUERY).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const onChange = () => setIsDesktop(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isDesktop;
}
